module.exports = require("./jquery-ui.js");


//////////////////
// WEBPACK FOOTER
// jquery-ui (bower component)
// module id = 1187
// module chunks = 0